import { render } from "./cwbg.vue?vue&type=template&id=765784f5&scoped=true&ts=true"
import script from "./cwbg.vue?vue&type=script&lang=ts"
export * from "./cwbg.vue?vue&type=script&lang=ts"

import "./cwbg.vue?vue&type=style&index=0&id=765784f5&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765784f5"]])

export default __exports__